'use strict';

var fix = {
    fixPixelRatio: function fixPixelRatio() {
        var scale = 1 / window.devicePixelRatio;
        var meta = '<meta name="viewport" content="initial-scale=' + scale + ', maximum-scale=' + scale + ',' + ' minimum-scale=' + scale + ', width=device-width,' + ' user-scalable=no" />';
        document.write(meta);
    },
    displayRem: function displayRem(width) {
        var designW = width;
        var font_rate = 100;

        document.getElementsByTagName("html")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";

        document.getElementsByTagName("body")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";

        window.addEventListener("orientationchange" in window ? "orientationchange" : "resize", function () {
            document.getElementsByTagName("html")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";
            document.getElementsByTagName("body")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";
        }, false);
    },
    init: function init() {
        var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 750;

        this.fixPixelRatio();
        this.displayRem(width);
    }
};
module.exports = fix;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/util/fix.js
// module id = 100
// module chunks = 7 8